import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, NonNullableFormBuilder, Validators } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import dayjs from 'dayjs';
import { DateRangeFormGroupType, DateRangeFormType } from '../models/date-range';
import { CalendarHeaderComponent } from './calendar-header/calendar-header.component';

@Component({
    selector: 'app-date-range',
    templateUrl: './date-range.component.html',
    styleUrls: ['./date-range.component.scss'],
    standalone: false,
})
export class DateRangeComponent implements OnInit {
    private today = dayjs().format();
    public dateRangeForm: DateRangeFormGroupType;
    public minDateAllowed: string;
    public maxDateAllowed: string;
    private dateHasChanged = false;
    public calendarHeader = CalendarHeaderComponent;

    get start(): AbstractControl<string> | null {
        return this.dateRangeForm.get('start');
    }

    get end(): AbstractControl<string> | null {
        return this.dateRangeForm.get('end');
    }

    @Input() maxDate = 90;
    @Input() isLoading = false;
    @Output() eventOnChangeRange = new EventEmitter<DateRangeFormType>();
    @Output() eventInitialRange = new EventEmitter<DateRangeFormType>();

    constructor(private fb: NonNullableFormBuilder) {}

    ngOnInit(): void {
        this.createForm();

        this.maxDateAllowed = this.today;
        this.minDateAllowed = dayjs('2011-01-02').format();
    }

    createForm(): void {
        const defaultStartDay = dayjs().subtract(7, 'days').format();

        this.dateRangeForm = this.fb.group({
            start: [defaultStartDay, Validators.required],
            end: [this.today, Validators.required],
        });

        this.eventInitialRange.emit(this.dateRangeForm.getRawValue());
    }

    dateChange(typeDate: string, event: MatDatepickerInputEvent<Date>): void {
        this.dateHasChanged = true;
        if (event?.value) {
            if (typeDate === 'startDate') {
                const today = dayjs();
                const startDate = dayjs(event.value);
                const minDiffDays: number = 1000 * 60 * 60 * 24 * this.maxDate;
                if (today.valueOf() > startDate.valueOf() + minDiffDays) {
                    this.maxDateAllowed = startDate.add(minDiffDays, 'ms').format();
                }
                this.dateRangeForm.patchValue({
                    end: '',
                });
            }
            if (typeDate === 'endDate') {
                this.maxDateAllowed = this.today;
            }
        }
        if (this.dateHasChanged && this.end?.value && this.start?.value) {
            this.dateHasChanged = false;
            this.eventOnChangeRange.emit(this.dateRangeForm.getRawValue());
        }
    }
}
